import { createCrudEndpoints, createExportEndpoint } from '@/core/utils'
import { TCustomer } from '.'
import { DataWithPagination } from '@/core/types'

export type TCustomers = DataWithPagination<TCustomer>

export const serviceConfig = {
  model: 'customers',
  version: 'v1',
}

const moduleServiceHandlers = createCrudEndpoints<TCustomers, TCustomer>(
  serviceConfig.model,
  serviceConfig.version,
)
const moduleExportHandlers = createExportEndpoint(serviceConfig.model)

export { moduleServiceHandlers, moduleExportHandlers }
